import React, { useState, useEffect, useRef } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { Capacitor } from '@capacitor/core';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { googleSignup, googleLogin, searchPlaces, getPlaceDetails  } from '../api';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';

const Auth = ({ onLoginSuccess }) => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [isSignup, setIsSignup] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  // ✅ NEW: Places API State - ADD THESE
const [placeSuggestions, setPlaceSuggestions] = useState([]);
const [showSuggestions, setShowSuggestions] = useState(false);
const [isLoadingPlaces, setIsLoadingPlaces] = useState(false);
const placeInputRef = useRef(null);
const searchTimeoutRef = useRef(null);

  
  // Birth details popup state
  const [showBirthDetailsPopup, setShowBirthDetailsPopup] = useState(false);
  const [googleCredential, setGoogleCredential] = useState(null);
  
  // Waiting list modal state
  const [showWaitingListModal, setShowWaitingListModal] = useState(false);
  const [contactNumber] = useState('+91-9999999999');
  
  // ✅ Enhanced Birth Details State with separate date fields
  const [birthDetails, setBirthDetails] = useState({
    full_name: '',
    birth_day: '',
    birth_month: '',
    birth_year: '',
    birth_time: '',
    birth_place: '',
    timezone: 'Asia/Kolkata'
  });

  // ✅ Date picker options
  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const months = [
    { value: 1, name: 'January' },
    { value: 2, name: 'February' },
    { value: 3, name: 'March' },
    { value: 4, name: 'April' },
    { value: 5, name: 'May' },
    { value: 6, name: 'June' },
    { value: 7, name: 'July' },
    { value: 8, name: 'August' },
    { value: 9, name: 'September' },
    { value: 10, name: 'October' },
    { value: 11, name: 'November' },
    { value: 12, name: 'December' }
  ];
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 100 }, (_, i) => currentYear - i);
  
  // ✅ Environment-based Client IDs
  const WEB_CLIENT_ID = process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID || "1039681193782-obmnqsvo8dvct21i1fum6dov74i0iqn2.apps.googleusercontent.com";
  const ANDROID_CLIENT_ID = process.env.REACT_APP_GOOGLE_ANDROID_CLIENT_ID || "1039681193782-m2ave3359vb9qu70b3sdars3inq6qc5s.apps.googleusercontent.com";
  
  // ✅ Platform detection
  const isNative = Capacitor.isNativePlatform && Capacitor.isNativePlatform();
  const isAndroid = Capacitor.getPlatform() === 'android';
  
  console.log('🔧 Platform detection:', {
    isNative,
    platform: Capacitor.getPlatform(),
    isAndroid,
    webClientId: WEB_CLIENT_ID,
    androidClientId: ANDROID_CLIENT_ID
  });

  // ✅ FIXED: Initialize Google Auth ONLY for native platforms
  useEffect(() => {
    const initializeGoogleAuth = async () => {
      if (isNative) {
        try {
          console.log('🚀 Initializing GoogleAuth for native platform');
          await GoogleAuth.initialize({
            clientId: WEB_CLIENT_ID,
            scopes: ['profile', 'email'],
            grantOfflineAccess: true,
          });
          console.log('✅ GoogleAuth initialized successfully');
        } catch (error) {
          console.error('❌ GoogleAuth initialization error:', error);
          setMessage('⚠️ Google Auth initialization failed. Please check your setup.');
        }
      } else {
        console.log('🌐 Web platform detected - using @react-oauth/google instead');
      }
    };

    initializeGoogleAuth();
  }, [isNative, WEB_CLIENT_ID]);

  useEffect(() => {
    const testBackend = async () => {
      try {
        console.log('🔍 Testing backend connectivity...');
        console.log('🌐 Backend URL:', process.env.REACT_APP_BACKEND);
        
        const response = await fetch(process.env.REACT_APP_BACKEND + '/health', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
        console.log('✅ Backend test response:', response.status);
        
        if (response.status === 404) {
          const baseResponse = await fetch(process.env.REACT_APP_BACKEND, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
          });
          console.log('✅ Backend base URL response:', baseResponse.status);
        }
      } catch (err) {
        console.error('❌ Backend connection test failed:', {
          message: err.message,
          name: err.name,
          stack: err.stack
        });
      }
    };
    
    testBackend();
  }, []);

  // ✅ NEW: Close suggestions when clicking outside - ADD THIS
useEffect(() => {
  const handleClickOutside = (event) => {
    if (placeInputRef.current && !placeInputRef.current.contains(event.target)) {
      setShowSuggestions(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
    // Cleanup timeout on unmount
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
  };
}, []);


const clearBirthDetails = () => {
  setBirthDetails({
    full_name: '',
    birth_day: '',
    birth_month: '',
    birth_year: '',
    birth_time: '',
    birth_place: '',
    timezone: 'Asia/Kolkata'
  });
  // ✅ NEW: Clear places suggestions - ADD THESE LINES
  setPlaceSuggestions([]);
  setShowSuggestions(false);
};


  // ✅ Handle birth details input changes
  const handleBirthDetailsChange = (field, value) => {
    setBirthDetails(prev => ({
      ...prev,
      [field]: value
    }));
  };
// ✅ NEW: Handle place input with backend API - ADD THIS FUNCTION
const handlePlaceInputChange = async (value) => {
  handleBirthDetailsChange('birth_place', value);
  
  // Clear existing timeout
  if (searchTimeoutRef.current) {
    clearTimeout(searchTimeoutRef.current);
  }
  
  if (!value || value.length < 2) {
    setPlaceSuggestions([]);
    setShowSuggestions(false);
    return;
  }

  // Debounce the API call by 300ms
  searchTimeoutRef.current = setTimeout(async () => {
    setIsLoadingPlaces(true);
    
    try {
      console.log('🔍 Searching places for:', value);
      const response = await searchPlaces(value);
      
      if (response.data && response.data.success) {
        const suggestions = response.data.places || [];
        setPlaceSuggestions(suggestions);
        setShowSuggestions(suggestions.length > 0);
      } else {
        setPlaceSuggestions([]);
        setShowSuggestions(false);
      }
    } catch (error) {
      console.error('❌ Error fetching place suggestions:', error);
      setPlaceSuggestions([]);
      setShowSuggestions(false);
    } finally {
      setIsLoadingPlaces(false);
    }
  }, 300);
};

// ✅ NEW: Handle place selection - ADD THIS FUNCTION
const handlePlaceSelect = (place) => {
  const fullPlace = place.description || `${place.main_text}, ${place.secondary_text}`;
  handleBirthDetailsChange('birth_place', fullPlace);
  setPlaceSuggestions([]);
  setShowSuggestions(false);
};



  // ✅ Validate birth date
  const isValidDate = () => {
    const { birth_day, birth_month, birth_year } = birthDetails;
    
    if (!birth_day || !birth_month || !birth_year) {
      return false;
    }

    const day = parseInt(birth_day);
    const month = parseInt(birth_month);
    const year = parseInt(birth_year);

    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && 
           date.getMonth() === month - 1 && 
           date.getDate() === day;
  };

  // ✅ Get days in selected month for validation
  const getDaysInMonth = () => {
    if (!birthDetails.birth_month || !birthDetails.birth_year) return 31;
    const month = parseInt(birthDetails.birth_month);
    const year = parseInt(birthDetails.birth_year);
    return new Date(year, month, 0).getDate();
  };

  // ✅ Web Google Auth handler
  const handleGoogleAuth = async (credentialResponse) => {
    console.log('🌐 Web Google Auth triggered');
    
    if (isSignup) {
      setGoogleCredential(credentialResponse.credential);
      setShowBirthDetailsPopup(true);
      setMessage('');
    } else {
      performLogin(credentialResponse.credential);
    }
  };

  // ✅ FIXED: Native Google Auth handler
  const handleNativeGoogleAuth = async () => {
    console.log('📱 Native Google Auth triggered');
    setIsLoading(true);
    setMessage('');
    
    try {
      // ✅ CRITICAL FIX: Initialize right before signIn for native
      await GoogleAuth.initialize({
        clientId: WEB_CLIENT_ID,
        scopes: ['profile', 'email'],
        grantOfflineAccess: true,
      });

      const result = await GoogleAuth.signIn();
      console.log('✅ Native Google Auth result:', JSON.stringify(result, null, 2));

      const credential = result.authentication?.idToken || result.idToken;
      
      console.log('🔑 Token type check:', {
        hasIdToken: !!result.authentication?.idToken,
        hasDirectIdToken: !!result.idToken,
        hasAccessToken: !!result.authentication?.accessToken,
        usingCredential: credential ? credential.substring(0, 50) + '...' : 'NO TOKEN'
      });
      
      if (!credential) {
        console.error('❌ No ID token found in result:', result);
        throw new Error('No ID token received from Google Auth. Check your Google Console configuration.');
      }

      if (isSignup) {
        setGoogleCredential(credential);
        setShowBirthDetailsPopup(true);
        setMessage('');
      } else {
        performLogin(credential);
      }
    } catch (err) {
      console.error('❌ Native Google Auth Failed:', {
        message: err.message,
        code: err.code,
        details: err
      });
      
      if (err.message?.includes('popup_closed_by_user')) {
        setMessage('⚠️ Sign-in was cancelled. Please try again.');
      } else if (err.message?.includes('SIGN_IN_CANCELLED')) {
        setMessage('⚠️ Sign-in was cancelled by user.');
      } else if (err.message?.includes('NETWORK_ERROR')) {
        setMessage('❌ Network error. Please check your internet connection.');
      } else {
        setMessage(`❌ Google authentication failed: ${err.message || 'Unknown error'}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const performLogin = async (credential) => {
    setIsLoading(true);
    setMessage('');
    
    try {
      console.log('🔑 Attempting login with credential...');
      const response = await googleLogin(credential);
      
      console.log('✅ Login response:', response.data);

      if (response.data.success) {
        setUser(response.data.user);
        setMessage(response.data.message);
        
        if (onLoginSuccess) onLoginSuccess(response.data.user);
        
        setTimeout(() => {
          navigate('/home');
        }, 1500);
      }

    } catch (err) {
      console.error('❌ Login error details:');
      
      if (err.response) {
        console.error('Response Error:', {
          status: err.response.status,
          statusText: err.response.statusText,
          data: err.response.data,
          headers: err.response.headers
        });
        
        if (err.response?.data) {
          const errorData = err.response.data;
          
          if (errorData.waitingList) {
            setShowWaitingListModal(true);
            setMessage('');
          } else if (errorData.needsSignup && !isSignup) {
            setMessage(`❌ ${errorData.message}`);
            setTimeout(() => {
              setIsSignup(true);
              setMessage('Switched to signup mode. Please create an account first.');
            }, 3000);
          } else {
            setMessage(`❌ ${errorData.message || 'Login failed'}`);
          }
        } else {
          setMessage(`❌ Server error: ${err.response.status} ${err.response.statusText}`);
        }
        
      } else if (err.request) {
        console.error('Network Error:', {
          request: err.request,
          code: err.code,
          message: err.message
        });
        setMessage('❌ Network error. Please check your internet connection.');
        
      } else {
        console.error('Request Setup Error:', {
          message: err.message,
          stack: err.stack
        });
        setMessage('❌ Request setup error. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleBirthDetailsSubmit = async () => {
    // Validate required fields
    if (!birthDetails.full_name.trim()) {
      setMessage('❌ Please enter your full name');
      return;
    }

    if (!isValidDate()) {
      setMessage('❌ Please select a valid birth date');
      return;
    }

    if (!birthDetails.birth_time.trim()) {
      setMessage('❌ Please enter your birth time');
      return;
    }

    if (!birthDetails.birth_place.trim()) {
      setMessage('❌ Please enter your birth place');
      return;
    }

    setIsLoading(true);
    setMessage('');
    
    try {
      // ✅ Combine date fields into proper date string
      const birthDate = `${birthDetails.birth_year}-${birthDetails.birth_month.toString().padStart(2, '0')}-${birthDetails.birth_day.toString().padStart(2, '0')}`;

      const profile = {
        full_name: birthDetails.full_name.trim(),
        birth_date: birthDate,
        birth_time: birthDetails.birth_time,
        birth_place: birthDetails.birth_place.trim(),
        timezone: birthDetails.timezone
      };

      console.log('📝 Attempting signup with profile...', profile);
      const response = await googleSignup(googleCredential, profile);
      
      console.log('✅ Signup response:', response.data);

      if (response.data.success) {
        if (response.data.waitingList) {
          setShowWaitingListModal(true);
          setShowBirthDetailsPopup(false);
          clearBirthDetails();
          setGoogleCredential(null);
        } else {
          setUser(response.data.user);
          setMessage(response.data.message);
          
          if (onLoginSuccess) onLoginSuccess(response.data.user);
          
          setShowBirthDetailsPopup(false);
          clearBirthDetails();
          setGoogleCredential(null);
          
          setTimeout(() => {
            navigate('/chat');
          }, 2000);
        }
      }

    } catch (err) {
      console.error('❌ Signup error:', err);
      
      if (err.response?.data) {
        const errorData = err.response.data;
        
        if (errorData.waitingList) {
          setShowWaitingListModal(true);
          setShowBirthDetailsPopup(false);
          clearBirthDetails();
          setGoogleCredential(null);
        } else if (errorData.userExists) {
          setMessage(`❌ ${errorData.message}`);
          setShowBirthDetailsPopup(false);
          clearBirthDetails();
          setGoogleCredential(null);
          
          setTimeout(() => {
            setIsSignup(false);
            setMessage('Account exists. Switched to login mode.');
          }, 3000);
        } else {
          setMessage(`❌ ${errorData.message || 'Signup failed'}`);
        }
      } else {
        setMessage('❌ Network error. Please check your connection.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const closeBirthDetailsPopup = () => {
    setShowBirthDetailsPopup(false);
    clearBirthDetails();
    setGoogleCredential(null);
    setMessage('');
  };

  const closeWaitingListModal = () => {
    setShowWaitingListModal(false);
  };

  const handleModeChange = (newMode) => {
    setIsSignup(newMode);
    setMessage('');
    if (showBirthDetailsPopup) {
      closeBirthDetailsPopup();
    }
    if (showWaitingListModal) {
      closeWaitingListModal();
    }
  };

  const copyContactNumber = () => {
    navigator.clipboard.writeText(contactNumber);
    alert('📞 Contact number copied to clipboard!');
  };

  return (
    <GoogleOAuthProvider clientId={WEB_CLIENT_ID}>
      <div className="auth-container">
        {/* Mystical Background Elements */}
        <div className="bg-element-auth sparkle">✨</div>
        <div className="bg-element-auth moon">🌙</div>
        <div className="bg-element-auth crystal">🔮</div>
        <div className="bg-element-auth star">⭐</div>

        {/* Main Auth Container */}
        <div className="auth-main-container">
          {/* Logo and Title */}
          <div className="auth-header">
            <div className="auth-logo">⭐</div>
            <h1 className="auth-title">ASTROGURU</h1>
            <p className="auth-subtitle">✨ Your Gateway to Cosmic Wisdom ✨</p>
          </div>

          {/* Signup/Login Toggle */}
          <div className="auth-toggle">
            <button
              onClick={() => handleModeChange(true)}
              className={`toggle-btn ${isSignup ? 'active' : ''}`}
            >
              📝 Sign Up
            </button>
            <button
              onClick={() => handleModeChange(false)}
              className={`toggle-btn ${!isSignup ? 'active' : ''}`}
            >
              🔑 Login
            </button>
          </div>

          {/* Status Message */}
          {message && (
            <div className={`status-message ${message.includes('❌') ? 'error' : message.includes('⚠️') ? 'warning' : 'success'}`}>
              {message}
            </div>
          )}

          {/* Google Auth Button Container */}
          <div className="google-auth-container">
            <p className="auth-instruction">
              {isLoading ? (
                '🌟 Connecting to the cosmos...'
              ) : (
                isSignup ? '🚀 Sign up with Google' : '🔑 Sign in with Google'
              )}
            </p>
            <div className="google-login-wrapper">
              {isNative ? (
                <button
                  className="google-native-btn"
                  onClick={handleNativeGoogleAuth}
                  disabled={isLoading}
                >
                  <span style={{marginRight: 8, fontSize: 20}}>🌐</span>
                  {isSignup ? 'Sign up with Google' : 'Sign in with Google'}
                </button>
              ) : (
                <GoogleLogin
                  onSuccess={handleGoogleAuth}
                  onError={(error) => {
                    console.error('❌ Web Google Auth Failed:', error);
                    if (error === 'popup_closed_by_user') {
                      setMessage('⚠️ Sign-in popup was closed. Please try again.');
                    } else {
                      setMessage('❌ Google authentication failed. Please try again.');
                    }
                  }}
                  theme="filled_blue"
                  size="large"
                  text={isSignup ? "signup_with" : "signin_with"}
                  shape="rectangular"
                  width="300"
                  disabled={isLoading}
                />
              )}
            </div>
          </div>

          {/* Platform Debug Info */}
          <div style={{fontSize: '10px', color: 'rgba(255,255,255,0.5)', textAlign: 'center', marginTop: '10px'}}>
            Platform: {Capacitor.getPlatform()} | Native: {isNative ? 'Yes' : 'No'}
          </div>

          {/* Features Preview */}
          <div className="features-preview">
            <div className="feature-preview kundli">
              <div className="preview-icon">🔮</div>
              <div className="preview-text">Free Kundli</div>
            </div>
            <div className="feature-preview pooja">
              <div className="preview-icon">📖</div>
              <div className="preview-text">Book Pooja</div>
            </div>
            <div className="feature-preview moon">
              <div className="preview-icon">🌙</div>
              <div className="preview-text">Moon Track</div>
            </div>
          </div>

          {/* Info Text */}
          <p className="auth-info-text">
            {isSignup ? (
              <>
                Secure signup with Google • Birth details for accurate readings<br/>
                🌟 Account activation required • Contact support for access 🌟
              </>
            ) : (
              <>
                Secure login with Google • Continue your journey<br/>
                🌟 Only activated accounts can login 🌟
              </>
            )}
          </p>
        </div>

        {/* ✅ ENHANCED BIRTH DETAILS MODAL WITH CUSTOM DATE PICKER */}
        {showBirthDetailsPopup && (
          <div className="modal-overlay">
            <div className="birth-details-modal">
              <button className="modal-close-btn" onClick={closeBirthDetailsPopup}>×</button>
              
              <div className="modal-header">
                <div className="modal-icon">🌟</div>
                <h2 className="modal-title">Complete Your Cosmic Profile</h2>
                <p className="modal-subtitle">
                  Please provide your birth details for accurate<br/>
                  astrological readings and personalized Kundli
                </p>
              </div>

              <div className="birth-form">
                <div className="form-grid">
                  {/* Full Name */}
                  <div className="form-field">
                    <label className="form-label">Full Name *</label>
                    <input
                      type="text"
                      value={birthDetails.full_name}
                      onChange={(e) => handleBirthDetailsChange('full_name', e.target.value)}
                      placeholder="Enter your complete name"
                      className="form-input"
                    />
                  </div>

                  {/* ✅ CUSTOM DATE PICKER */}
                  <div className="form-field">
                    <label className="form-label">Birth Date *</label>
                    <div className="date-picker-grid">
                      {/* Day Dropdown */}
                      <select
                        className="form-select"
                        value={birthDetails.birth_day}
                        onChange={(e) => handleBirthDetailsChange('birth_day', e.target.value)}
                        required
                      >
                        <option value="">Day</option>
                        {days.slice(0, getDaysInMonth()).map(day => (
                          <option key={day} value={day}>
                            {day.toString().padStart(2, '0')}
                          </option>
                        ))}
                      </select>

                      {/* Month Dropdown */}
                      <select
                        className="form-select"
                        value={birthDetails.birth_month}
                        onChange={(e) => handleBirthDetailsChange('birth_month', e.target.value)}
                        required
                      >
                        <option value="">Month</option>
                        {months.map(month => (
                          <option key={month.value} value={month.value}>
                            {month.name}
                          </option>
                        ))}
                      </select>

                      {/* Year Dropdown */}
                      <select
                        className="form-select"
                        value={birthDetails.birth_year}
                        onChange={(e) => handleBirthDetailsChange('birth_year', e.target.value)}
                        required
                      >
                        <option value="">Year</option>
                        {years.map(year => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                    {birthDetails.birth_day && birthDetails.birth_month && birthDetails.birth_year && !isValidDate() && (
                      <div className="date-error">
                        ⚠️ Please select a valid date
                      </div>
                    )}
                  </div>

                  {/* Birth Time */}
                  <div className="form-field">
                    <label className="form-label">Birth Time *</label>
                    <input
                      type="time"
                      value={birthDetails.birth_time}
                      onChange={(e) => handleBirthDetailsChange('birth_time', e.target.value)}
                      className="form-input"
                    />
                  </div>

               {/* ✅ NEW: ENHANCED BIRTH PLACE WITH PLACES AUTOCOMPLETE */}
<div className="form-field" ref={placeInputRef}>
  <label className="form-label">Birth Place (India Only) *</label>
  <div className="place-input-container">
    <input
      type="text"
      value={birthDetails.birth_place}
      onChange={(e) => handlePlaceInputChange(e.target.value)}
      placeholder="Start typing Indian city name or pincode..."
      className="form-input place-input"
      autoComplete="off"
    />
    {isLoadingPlaces && (
      <div className="place-loading-icon">🔄</div>
    )}
  </div>
  
  {/* Places Suggestions Dropdown */}
  {showSuggestions && placeSuggestions.length > 0 && (
    <div className="place-suggestions">
      {placeSuggestions.map((place, index) => (
        <div
          key={place.place_id || index}
          className="place-suggestion-item"
          onClick={() => handlePlaceSelect(place)}
        >
          <div className="place-main-text">📍 {place.main_text || place.name}</div>
          <div className="place-secondary-text">
            {place.secondary_text || place.formatted_address || place.description}
          </div>
        </div>
      ))}
    </div>
  )}
  
  {/* No suggestions message */}
  {showSuggestions && placeSuggestions.length === 0 && !isLoadingPlaces && birthDetails.birth_place.length > 2 && (
    <div className="place-no-suggestions">
      🔍 No Indian places found. Try typing a different location.
    </div>
  )}
</div>


                  {/* Timezone */}
                  <div className="form-field">
                    <label className="form-label">Timezone</label>
                    <select
                      className="form-select"
                      value={birthDetails.timezone}
                      onChange={(e) => handleBirthDetailsChange('timezone', e.target.value)}
                    >
                      <option value="Asia/Kolkata">India Standard Time (IST)</option>
                      <option value="America/New_York">Eastern Time (EST)</option>
                      <option value="America/Chicago">Central Time (CST)</option>
                      <option value="America/Denver">Mountain Time (MST)</option>
                      <option value="America/Los_Angeles">Pacific Time (PST)</option>
                      <option value="Europe/London">Greenwich Mean Time (GMT)</option>
                      <option value="Europe/Paris">Central European Time (CET)</option>
                      <option value="Asia/Tokyo">Japan Standard Time (JST)</option>
                      <option value="Australia/Sydney">Australian Eastern Time (AET)</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-info">
                🔮 Your birth details are used to generate accurate astrological charts and personalized readings. All information is kept confidential and secure.
              </div>

              <div className="modal-buttons">
                <button onClick={closeBirthDetailsPopup} disabled={isLoading} className="btn-secondary">
                  Cancel
                </button>
                <button onClick={handleBirthDetailsSubmit} disabled={isLoading} className="btn-primary">
                  {isLoading ? (
                    <>
                      <span>🌟</span>
                      <span>Creating Account...</span>
                    </>
                  ) : (
                    <>
                      <span>✨</span>
                      <span>Create Account</span>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Waiting List Modal */}
        {showWaitingListModal && (
          <div className="modal-overlay">
            <div className="waiting-list-modal">
              <div className="waiting-icon">⏳</div>
              <h2 className="waiting-title">You're on the Waiting List!</h2>
              
              <div className="waiting-message">
                <p className="waiting-success">🎉 Your account has been created successfully!</p>
                <p className="waiting-description">
                  You are currently in our activation queue. Please contact our Master Astrologer for account activation.
                </p>
                
                <div className="contact-info">
                  <div className="contact-title">📞 Contact Master Astrologer</div>
                  <div className="contact-number" onClick={copyContactNumber}>
                    {contactNumber}
                  </div>
                  <p className="contact-hint">Click to copy number</p>
                </div>
              </div>

              <button className="waiting-close-btn" onClick={closeWaitingListModal}>
                ✅ Got it, Thanks!
              </button>
            </div>
          </div>
        )}

        {/* Bottom Copyright */}
        <div className="auth-copyright">
          © 2025 AstroGuru • Secure Authentication • Activation Required
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default Auth;
